import {getLeafString, dash, dot} from 'effects/midi/tidal/parser.js';
import Stackable from "utils/Stackable.js";
import {mod} from 'utils/mod.js';
import JakiConnectable from './JakiConnectable.js';
import {setJakiGrid} from 'actions/index.js';
import {GRID_OPERATION, RULES} from "messaging/message-types.js";
import NodeMessaging from "messaging/NodeMessaging.js";
import GridOperations from './GridOperations.js';
import GridRules from './GridRules.js';
import {
    applyToLeaf,
    applyRule,
    before,
    after,
    when ,
    otherwise,
    ACCENT,
    FLAM,
    STACCATO,
    DOUBLE,
    REST,
    LEGATO,
    PIANO,
    PIANISSIMO
} from 'effects/midi/scripting/trules.js';
import {uuid} from 'uuidv4';
import {MAX_OPERATIONS} from './GridOperations.js';

export default class JakiGrid extends Stackable(GridOperations(JakiConnectable(GridRules(NodeMessaging(class {}))))) {
    constructor(subSequence, object) {
        super();
        this.id = uuid();
        this.subSequence = subSequence;
        this.zObject = object;
        this.size = 15;
        this.cells = [];
        this.symbols = [];

        for (let i=0; i < this.size; i++) {
            this.cells.push(new Array(this.size).fill(false));
        }

        this.newInlet(GRID_OPERATION, (msg) => this.onOperation(msg[0]));
        this.newOutlet(RULES);

        this.newInlet("save", () => this.save());
        this.newInlet("restore", ([obj]) => this.restore(obj));
        this.newInlet("interpolate", ([cells]) => this.interpolate(cells));
        this.newInlet("interpolation factor", ([factor]) => {if (!isNaN(factor)) {this.interpolationFactor = factor;}});
        this.newOutlet("saved");
        this.newOutlet("density");

        this.interpolationFactor = .5;
    }

    interpolate(cells) {
        if (this.zObject.sequencerEngine.isLoading) {
            return;
        }
        if (this.lastStepNumber !== this.zObject.sequencerEngine.trackStep) {
            this.operationsCount = 0;
        }
        if (this.operationsCount++ > MAX_OPERATIONS) {
            return;
        } 

        this.lastStepNumber = this.zObject.sequencerEngine.trackStep;
        
        for (let rowNumber=0; rowNumber < cells.length; rowNumber++) {
            let row = cells[rowNumber];
            for (let colNumber=0; colNumber < row.length; colNumber++) {
                let cell = row[colNumber];
                let flip = Math.random();
                if (flip < this.interpolationFactor) {
                    // use this cell
                    if (typeof cell === "object") {
                        this.cells[rowNumber][colNumber] = {... cell};
                    } else {
                        this.cells[rowNumber][colNumber] = cell;
                    }
                }
            }
        }
        this.updateRedux();
        this.calculateRules();
    }

    // returnw the current grid
    get current() {
        return this.cells;
    }

    set current(c) {
        this.cells = c;
        this.calculateRules();
        this.updateRedux();
    }

    getCurrentCopy(cells=this.cells) {
        let current = cells;
        let copy = [];
        for (let c of current) {
            let _c = [];
            for (let  d of c) {
                _c.push(!d ? false : typeof d === "string" ? d : {... d});
            }
            copy.push(_c);
        }
        return copy;
    }


    getConnectedTidal(number=0) {
        return super.getConnectedTidal(number, "rules");
    }

    set(x,y, obj) {
        if (x >= this.size || y >= this.size) {
            return;
        }
        this.cells[y][x] = obj;
        this.calculateRules();
        this.updateRedux();
    }

    drag(x1, y1, x2, y2, update=true) {
        if (x1===x2 && y1 === y2) {
            return;
        }
        let cell = this.cells[y1][x1];
        if (this.cells[y2][x2]) {
            // dont let it
            return false;
        }
        this.cells[y2][x2] = cell;
        this.cells[y1][x1] = false;

        if (update) {
            this.calculateRules();
            this.updateRedux();
        }
        return true;
    }

    updateRedux() {
        this.zObject.dispatch(
            setJakiGrid(this.id, [... this.cells]));
    }

    getParameters() {
        return [];
    }

    getSelected({x1, y1, x2, y2}) {
        let selected = {};

        for (let i=y1; i <= y2; i++) {
            for (let j=x1; j <= x2; j++) {
                if (this.cells[i][j]) {
                    selected[j+','+i] = true;
                }
            }
        }

        return selected;
    }

    getJson() {
        return {
            id: this.id,
            cells: this.cells
        };
    }

    fromJson(json) {
        if (json.id) {
            this.id = json.id;
        }
        
        if (json.cells) {
            this.cells = json.cells;
            this.calculateRules();
        }
    }

}
